<style lang="less" scoped>
.value {
    padding: 5px;
    width: 100%;
    display: inline-block;
    text-align: center;
}
.select_p {
  cursor: pointer;
  margin: 15px 0;
}
.print-container_in {
  width: 100%;
  table {
    width: 100%;
  }
}
.print-container{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    font-size: 14px;
    z-index: 10000;
    color: #000;
    background: white;
}
.screening-condition {
          display: none;
        }
    @media print {
        .screening-condition {
          display: block;
        }
        .value {
            white-space: nowrap;
            font-size: 1mm;
            width: 100%;
            display: inline-block;
            text-align: center;
        }
    }
</style>
<template>
  <div>
    <Spin
      v-if="getDataLoading"
      fix
    />
    <div style="margin:10px 0">
      <DatePicker
        v-model="params.month"
        type="month"
        :clearable="false"
        placeholder="请选择日期"
        style="width: 160px"
        @on-change="changeParams"
      />
      <DatePicker
        v-model="params.end_month"
        type="month"
        placeholder="请选择日期"
        style="width: 160px;margin-left:10px"
        :options="optionsEnd"
        @on-change="changeParams"
      />
      <Select
        v-model="params.buyer"
        placeholder="请选择公司"
        style="width: 200px;margin-left:10px"
        @on-change="changeParams"
      >
        <Option
          v-for="item in companies "
          :key="item.name"
          :value="item.name"
        >
          {{ item.name }}
        </Option>
      </Select>
      <Select
        v-model="params.related_BX"
        placeholder="付款类型"
        style="width: 160px;margin-left:10px"
        @on-change="changeParams"
      >
        <Option
          v-for="item in payment_type "
          :key="item.title"
          :value="item.value"
        >
          {{ item.title }}
        </Option>
      </Select>
      <Select
        v-model="params.invoice_type"
        placeholder="发票类型"
        clearable
        style="width: 160px;margin-left:10px"
        @on-change="changeParams"
      >
        <Option
          v-for="item in invoice_types "
          :key="item.name"
          :value="item.value"
        >
          {{ item.name }}
        </Option>
      </Select>
      <Select
        v-model="params.invoice_form"
        placeholder="发票形态"
        clearable
        style="width: 160px;margin-left:10px"
        @on-change="changeParams"
        @on-clear="changeParams"
      >
        <!--   case 'electronic':
                    str = '电子'
                    break;
                case 'paper': -->
        <Option
          value="electronic"
        >
          电子
        </Option>
        <Option
          value="paper"
        >
          纸质
        </Option>
      </Select>
      <div style="display: inline-block;">
        <Button
          style="margin-left:10px"
          type="primary"
          @click="printFun"
        >
          打印
        </Button>
        <Button
          style="margin-left:10px"
          type="primary"
          @click="outputExcel"
        >
          导出excel
        </Button>
      </div>
    </div>
    <div
      ref="#print_list"
      class="contain-out"
      :class="{
        'print-container':showPrint
      }"
    >
      <div class="screening-condition">
        筛选条件：<span>月份：{{ print_detail.month }}</span>；
        <span>公司：{{ print_detail.buyer }}</span>；
        <span>付款类型：{{ print_detail.related_BX }}</span>；
      </div>
      <div
        class="print-container_in"
      >
        <table
          ref="#out-table"
          class="print-container_out "
          style="border-collapse:collapse;"
          border="1"
        >
          <thead>
            <tr>
              <th
                v-for="(item) in print_table_fields"
                :key="item.key"
                class="value_td"
              >
                <span class="value">
                  {{ item.title }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(invoice,index) in table_list"
              :key="index"
            >
              <td
                v-for="(item,itemIndex) in print_table_fields"
                :key="itemIndex"
                class="value_td"
              >
                <span class="value">
                  {{ item.render? item.render(invoice):toTargetStr(invoice[item.key]) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script route="/invoice/invoice_print">
  import { print_table_fields, payment_type } from './fields'
  import moment from 'moment'
  import FileSaver from 'file-saver'
  import { write, utils } from 'xlsx'
  import util from '@/views/invoice/libs/util.js'
  const LOCALSTORAGE_INVOICE_INVOICE_PRINT = 'localstorage_invoice_invoice_print'
  export default {
    /* router_info_start */
    router_info: '/invoice/invoice_print',
    /* router_info_end */

    data() {
      this.print_table_fields = print_table_fields
      this.payment_type = payment_type
      this.payment_type_hash = payment_type.reduce((total, item) => {
        total[item.value] = item._val
        return total
      }, {})
      this.payment_type_title_hash = payment_type.reduce((total, item) => {
        total[item.value] = item.title
        return total
      }, {})
      const localstorage_invoice_invoice_print = localStorage.getItem(LOCALSTORAGE_INVOICE_INVOICE_PRINT)
      const params = {
        month: moment(new Date()).format('YYYY-MM'),
        end_month: moment(new Date()).format('YYYY-MM'),
        buyer:'全部公司',
        related_BX:'all',
        invoice_form: ''
      }
      if (localstorage_invoice_invoice_print) {
        const query = JSON.parse(localstorage_invoice_invoice_print)
        if (Object.prototype.toString.apply(query) !== "[object Object]") {
          return
        }
        Object.keys(params).forEach(key => {
          params[key] = query[key] || params[key]
        })
        localStorage.removeItem(LOCALSTORAGE_INVOICE_INVOICE_PRINT)
      }
      return {
        showPrint:false,
        invoices:[],
        print_invoices:[],
        getDataLoading: false,
        params: {
          ...params,
          invoice_type: null,
        },
        invoice_types : util.invoice_types
      }
    },
    computed: {
      optionsEnd() {
        return {
          disabledDate: (date) => {
            return this.params.month && date.valueOf() < this.params.month.valueOf()
          }
        }
      },
      table_list() {
        if ([undefined, null, ''].includes(this.params.invoice_type) || this.params.invoice_type === -1) {
          return this.invoices
        }
        return this.invoices.filter(item => item.invoice_type === this.params.invoice_type)
        // invoice_type
      },
      companies() {
        return [{ name:'全部公司'}, ...this.$store.getters['async/companies']]
      },
      print_detail() {
        const {mouth, buyer, related_BX} = this.params
        return {
          month: moment(mouth).format('YYYY-MM'),
          buyer,
          related_BX: this.payment_type_title_hash[related_BX],
        }
      }
    },
    mounted() {
      this.getTableData()
    },
    methods: {
     
      toTargetStr(target) {
        if (target === '' || target === undefined || target === null) {
          return ''
        }
        return target + ''
      },
      getTableData() {
        const { month, buyer, related_BX, end_month, invoice_form } = this.params
        const params = {
          month: moment(month).format('YYYY-MM'),
          end_month: moment(end_month).format('YYYY-MM'),
          buyer:buyer === '全部公司' ? '' : buyer,
          related_BX: this.payment_type_hash[related_BX],
          invoice_form
        }
        if (params.end_month < params.month) {
          delete params.end_month
          this.params.end_month = null
        }
        this.getDataLoading = true
        Util.ajax.get('invoice/credentials_list', { params }).then((response) => {
          return response.data;
        }).then(({ data, code, msg }) => {
          if (code !== 1) {
            this.invoices = []
            this.print_invoices = []
            this.$Modal.error({
              title: '错误',
              content: msg
            });
            return
          }
          if (data.invoices && data.invoices.length > 0) {
            const arr = []
            const print_invoices = []
            for (let i = 0; i < data.invoices.length; i++) {
              const { expense_groups, ...other } = data.invoices[i]
              let obj = {...other, _index:i + 1}
              print_invoices.push(other)
              if (expense_groups.length === 0) {
                arr.push(obj)
              }
              for (let j = 0; j < expense_groups.length; j++) {
                const child = Object.keys(expense_groups[j]).reduce((total, key) => {
                  total['expense_groups_' + key] = expense_groups[j][key]
                  return total
                }, {})
                if (j === 0) {
                  obj = {...obj, ...child}
                  arr.push(obj)
                } else {
                  arr.push(child)
                }
              }
            }
            this.invoices = arr
            this.print_invoices = print_invoices
          } else {
            this.invoices = []
            this.print_invoices = []
          }
        }).catch(() => {
          this.$Modal.error({
            title: '错误',
            content: '网络错误'
          });
          this.invoices = []
          this.print_invoices = []
        }).finally(() => {
          this.getDataLoading = false
        })
      },
      printFun() { // 打印
        window.document.body.innerHTML = this.$refs['#print_list'].innerHTML
        this.showPrint = true
        window.print()
        const { query = {}, path } = this.$router.currentRoute
        const { buyer, month, related_BX } = this.params
        const params = {
          ...query,
          rt: +new Date(),
        }
        const localstorage_invoice_invoice_print = {
          month: moment(month).format('YYYY-MM'),
          related_BX,
          buyer
        }
        localStorage.setItem(LOCALSTORAGE_INVOICE_INVOICE_PRINT, JSON.stringify(localstorage_invoice_invoice_print))
        const query_str = Object.keys(params).reduce((total, key) => total + `${total ? '&' : ''}${key}=${params[key]}`, '')
        window.location.href = window.location.origin + path + '?' + query_str
      },
      changeParams(data) {
        // console.log('data', data)
        // if (!data) {
        //   return
        // }
        this.getTableData()
      },
      outputExcel() { // 导出excel
        /* generate workbook object from table */
        const params = this.params
        // const wb = XLSX.utils.table_to_book(this.$refs['#out-table'])
        // const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
        const wb = utils.table_to_book(this.$refs['#out-table'])
        const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
        try {
          FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), `${moment(params.month).format('YYYY-MM')}_${params.buyer}_${this.payment_type_title_hash[params.related_BX]}.xlsx`)
        } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
        return wbout
      }
    }
  }
</script>
